import {
  GetEssEnergyAnalysisStats,
  GetEssStationEnergyMonitor,
  GetEssStationPvMonitor,
} from '@/api/evses'
import { EssEnergyChart } from '@/types/common/station'
import { StatisticsTimeGrain } from '@/types/types'
import { EssEnergyGrowthTrendChartData } from '../Photovoltaic/types'
import { onUnmounted, ref } from 'vue'

export const useEnergyAnalysisStats = () => {
  const essEnergyAnalysisStatsChartData = ref<EssEnergyGrowthTrendChartData>({})

  const fetchEssEnergyAnalysisStats = (grain: StatisticsTimeGrain, stationId: string) => {
    GetEssEnergyAnalysisStats({
      grain,
      stationId,
    }).then((res: { list: EssEnergyChart[] }) => {
      essEnergyAnalysisStatsChartData.value = {
        xAxisData: res.list.map((item) => item.time),
        seriesData: [
          {
            name: '储能充电量',
            data: res.list.map((item) => item.chargeEnergy),
          },
          {
            name: '储能放电量',
            data: res.list.map((item) => item.dischargeEnergy),
          },
          {
            name: '光伏PV发电量',
            data: res.list.map((item) => item.genEnergy),
          },
          // {
          //   name: '储能柜馈网电量',
          //   data: res.list.map((item) => item.feedbackGridEnergy),
          // },
          // {
          //   name: '光伏馈网电量',
          //   data: res.list.map((item) => item.feedbackGridEnergyPV),
          // },
        ],
      }
    })
  }

  const genEnergy = ref<number>(0)
  const fetchEssStationPvMonitor = (stationId: string) => {
    GetEssStationPvMonitor({
      stationId,
    }).then((res: { genEnergy: number }) => {
      genEnergy.value = res.genEnergy
    })
  }
  const chargeEnergy = ref<number>(0)
  const dischargeEnergy = ref<number>(0)
  const fetchEssStationEnergyMonitor = (stationId: string) => {
    GetEssStationEnergyMonitor({
      stationId,
    }).then((res: any) => {
      chargeEnergy.value = res.chargeEnergy
      dischargeEnergy.value = res.dischargeEnergy
    })
  }

  return {
    fetchEssEnergyAnalysisStats,
    genEnergy,
    chargeEnergy,
    dischargeEnergy,
    fetchEssStationPvMonitor,
    fetchEssStationEnergyMonitor,
    essEnergyAnalysisStatsChartData,
  }
}
